var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.75H4.25V6L9.5 0.75L10.4375 1.6875C10.525 1.775 10.5969 1.89375 10.6531 2.04375C10.7094 2.19375 10.7375 2.3375 10.7375 2.475V2.7375L9.9125 6H14.75C15.15 6 15.5 6.15 15.8 6.45C16.1 6.75 16.25 7.1 16.25 7.5V9C16.25 9.0875 16.2375 9.18125 16.2125 9.28125C16.1875 9.38125 16.1625 9.475 16.1375 9.5625L13.8875 14.85C13.775 15.1 13.5875 15.3125 13.325 15.4875C13.0625 15.6625 12.7875 15.75 12.5 15.75ZM5.75 14.25H12.5L14.75 9V7.5H8L9.0125 3.375L5.75 6.6375V14.25ZM4.25 6V7.5H2V14.25H4.25V15.75H0.5V6H4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.19841e7290218384c13e609542a3e67a.svg";
export { ForwardRef as ReactComponent };